/*
 * ap-felgen-finder.js — fuellt die Felgen-Kaskade (Zoll -> Lochkreis -> ET)
 * aus dem App-Proxy /apps/tyre-search/wheel-sizes:
 *
 *   { diameters: ["16.0","17.0",…], tree: { "17.0": { "5x112": [35,40,45] } } }
 *
 * Schluessel sind zeichengleich mit den wheel.*-Metafeldern (Vertrag der App).
 * Der Abschnitt startet [hidden] und erscheint erst mit gefuellten Listen —
 * statische Fallback-Listen waeren erfunden. Beim Absenden fragt zuerst die
 * gemeinsame Zielfunktion window.apSizeTarget (assets/ap-size-target.js) nach
 * der Zoll+LK-Kollektion; ohne Antwort bleibt es beim NATIVEN GET auf
 * /search, die Select-Namen SIND die Filterparameter. Ein leeres ET-Feld wird
 * vor dem Absenden deaktiviert, damit kein leerer Parameter mitgeht (der
 * wuerde als Filter auf "leer" wirken und alles ausblenden).
 *
 * Anzeige der Zoll-Werte ohne die ".0"-Endung des Vertragsformats — der WERT
 * bleibt das Vertragsformat, nur das Label ist menschlich ("17" bzw. "16.5").
 */

(function () {
  'use strict';

  function option(value, label) {
    var o = document.createElement('option');
    o.value = value;
    o.textContent = label;
    return o;
  }

  function zollLabel(d) {
    return String(d).replace(/\.0$/, '');
  }

  // NUR die Anzeige deutsch (Art-Director Feinschliff II R2, 28.09.2026): Karten und
  // Chips schreiben seit R1 „LK 6×114,3", „8,0 × 18″" — der Finder zeigte „5x114.3",
  // „17\"" und „ET 35.5". Der Wert (value) und die Zielfunktion bleiben unveraendert.
  var DEUTSCH = /^de/i.test(document.documentElement.getAttribute('lang') || 'de');

  function zahlAnzeige(s) {
    var t = String(s);
    return DEUTSCH ? t.replace('.', ',') : t;
  }

  function lkAnzeige(p) {
    return zahlAnzeige(String(p).replace(/x/i, '×'));
  }

  function resetSelect(sel, placeholderText) {
    while (sel.options.length > 1) sel.remove(1);
    sel.options[0].textContent = placeholderText;
  }

  function init(root) {
    var proxy = root.getAttribute('data-proxy');
    if (!proxy) return;

    var zoll = root.querySelector('[data-ff-part="zoll"]');
    var lk = root.querySelector('[data-ff-part="lk"]');
    var et = root.querySelector('[data-ff-part="et"]');
    var submit = root.querySelector('button[type="submit"]');
    var form = root.querySelector('form');
    if (!zoll || !lk || !et || !submit || !form) return;

    var lkPlaceholder = lk.options[0].textContent;
    var etPlaceholder = et.options[0].textContent;
    var tree = null;

    function syncSubmit() {
      submit.disabled = !(zoll.value && lk.value);
    }

    function fillLk() {
      resetSelect(lk, lkPlaceholder);
      resetSelect(et, etPlaceholder);
      var branch = tree && tree[zoll.value];
      if (branch) {
        Object.keys(branch)
          .sort(function (a, b) {
            return a.localeCompare(b, 'de', { numeric: true });
          })
          .forEach(function (pattern) {
            lk.appendChild(option(pattern, lkAnzeige(pattern)));
          });
      }
      syncSubmit();
    }

    function fillEt() {
      resetSelect(et, etPlaceholder);
      var branch = tree && tree[zoll.value];
      var ets = branch && branch[lk.value];
      if (Array.isArray(ets)) {
        ets
          .slice()
          .sort(function (a, b) {
            return Number(a) - Number(b);
          })
          .forEach(function (val) {
            et.appendChild(option(String(val), 'ET ' + zahlAnzeige(val)));
          });
      }
      syncSubmit();
    }

    zoll.addEventListener('change', fillLk);
    lk.addEventListener('change', fillEt);
    et.addEventListener('change', syncSubmit);

    form.addEventListener('submit', function (event) {
      // Leere optionale Felder nicht mitsenden — ein leerer Filterparameter
      // filtert sonst auf "leer" und blendet alles aus.
      if (!et.value) et.disabled = true;

      // ZIELFUNKTION ZUERST (assets/ap-size-target.js, Befund finden-felgen-finder-
      // zoll-wirkungslos): /search ist bei rund 1.000 Dokumenten gedeckelt, "17 Zoll +
      // LK 5x112" zeigte dort keine einzige 17-Zoll-Felge. Das richtige Ziel
      // (felgen-17-zoll-lk-5x112 mit ET-Facette) kennt nur die App — der Handle wird
      // hier NIE zusammengesetzt (LK 5x114.3 heisst dort -lk-5x114-3). Ohne Antwort
      // bleibt es beim bisherigen, nativen Absenden auf /search.
      var ask = window.apSizeTarget;
      if (typeof ask !== 'function' || !zoll.value || !lk.value) return;
      event.preventDefault();
      form.setAttribute('aria-busy', 'true');
      var params = { kind: 'wheel', d: zollLabel(zoll.value), pcd: lk.value, et: et.value };
      ask(params).then(
        function (url) {
          if (url) {
            window.location.assign(url);
            return;
          }
          nativeSubmit();
        },
        nativeSubmit
      );
    });

    // Das bisherige Ziel: der native GET mit den Feldnamen als Filterparametern.
    // HTMLFormElement.submit() loest kein submit-Ereignis aus — kein Kreislauf.
    function nativeSubmit() {
      et.disabled = !et.value;
      HTMLFormElement.prototype.submit.call(form);
    }

    // Zurueck-Taste (bfcache): das ET-Feld kaeme sonst gesperrt zurueck und fehlte
    // beim naechsten Absenden, auch wenn der Kunde einen Wert waehlt.
    window.addEventListener('pageshow', function () {
      et.disabled = false;
      form.removeAttribute('aria-busy');
    });

    fetch(proxy, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.diameters) || !data.tree) return;
        if (!data.diameters.length) return;
        tree = data.tree;
        data.diameters
          .slice()
          .sort(function (a, b) {
            return Number(a) - Number(b);
          })
          .forEach(function (d) {
            zoll.appendChild(option(String(d), zahlAnzeige(zollLabel(d)) + '″'));
          });
        root.hidden = false;
      })
      .catch(function () {
        /* Proxy nicht erreichbar — der Abschnitt bleibt unsichtbar. */
      });
  }

  // Handy-Aufklapper (mobile_fold): die Ueberschrift ist unter 750 px ein
  // Knopf; zugeklappt ist per CSS, hier wird nur umgeschaltet. Unabhaengig vom
  // Proxy — der Hinweistext im Koerper steht auch ohne Baum.
  function initToggle(btn) {
    var body = document.getElementById(btn.getAttribute('aria-controls') || '');
    if (!body) return;
    btn.addEventListener('click', function () {
      var auf = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
      body.classList.toggle('is-open', auf);
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ap-felgen-finder]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
    var toggles = document.querySelectorAll('[data-ff-toggle]');
    for (var j = 0; j < toggles.length; j++) initToggle(toggles[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
